
    var utils = require("!!/Users/v625154/work/perspective/packages/perspective-webpack-plugin/src/js/utils.js");
    module.exports = utils.publicPath(__webpack_public_path__) + "psp.sync.wasm";
    


//////////////////
// WEBPACK FOOTER
// ./cjs/js/psp.sync.wasm.js
// module id = 234
// module chunks = 0